// extracted by mini-css-extract-plugin
export default {"timer":"PrepTime_timer__F7B3f"};